import React, { FC } from 'react';
import { formatPhoneNumber } from 'Shared/utils';
import { UserRecordType } from 'Admin/services/endpoints/PostAttributionTypeahead';

import styles from './styles.module.css';

type AgentDetailsProps = { agent?: UserRecordType | null };

export const AgentDetails: FC<AgentDetailsProps> = ({ agent }) => {
  if (!agent) return null;
  return (
    <div className={styles.wrapper} data-testid="agent-details">
      <div className={styles.heading}>Agent Details</div>
      <div>{agent.name}</div>
      <div>{agent.email}</div>
      {agent.phone && (
        <div data-testid="agent-phone">{formatPhoneNumber(agent.phone)}</div>
      )}
    </div>
  );
};
